const SITEBAR_HEIGHT = 50;

export default function anchorLinkOffset() {
  window.addEventListener('hashchange', () => {
    if (location?.hash?.length !== 0) {
      window.scrollTo(window.scrollX, window.scrollY - SITEBAR_HEIGHT - 5);
    }
  });
}
